import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';
import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';

export class AssetStorageName extends PrimitiveValueObject<string> {
  static create(value: string): AssetStorageName {
    if (value === null) {
      throw new ArgumentNullException();
    }
    return new AssetStorageName(value);
  }
}
